<br />

<h1>{{ title.getTitle() }}</h1>

<hr />

<pcg-table [canGlobalSearch]='false' [multipleSearch]='false' [pcgSort]='[[ "goLiveDateString", "desc" ]]' dataSource='api/ReleaseNotes/GetMobileReleaseNotesList' [columnDefs]='columns'>
	<ng-container cdkColumnDef='versionNumber'>
		<th class='text-center' cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('versionNumber').displayName }}</th>
		<td class='text-center' cdk-cell *cdkCellDef='let row'>
			{{ row.versionNumber }}
		</td>
	</ng-container>

	<ng-container cdkColumnDef='goLiveDateString'>
		<th class='text-center' cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('goLiveDateString').displayName }}</th>
		<td class='text-center' cdk-cell *cdkCellDef='let row'>
			{{ row.goLiveDateString }}
		</td>
	</ng-container>

	<ng-container cdkColumnDef='releaseNotes'>
		<th class='text-center' cdk-header-cell *cdkHeaderCellDef>{{ columns.get('releaseNotes').displayName }}</th>
		<td cdk-cell *cdkCellDef='let row' [innerHTML]='row.releaseNotes'></td>
	</ng-container>
</pcg-table>
